import { IgDialog } from "@intelligems/ig-theme/IgDialog";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Stack from "@mui/material/Stack";
import { acknowledgeOnsiteEditorDeprecation } from "@src/features/experiments/components/onsiteEdits/onsiteEditorDeprecation";
import { useDialog } from "@src/hooks/dialog";

interface OnsiteEditorDeprecationDialogProps {
  onAcknowledge: () => void;
  onContactUs: () => void;
}

export const OnsiteEditorDeprecationDialog = ({
  onAcknowledge,
  onContactUs,
}: OnsiteEditorDeprecationDialogProps) => {
  const dialog = useDialog("onsiteEditorDeprecation");

  const acknowledge = () => {
    acknowledgeOnsiteEditorDeprecation();
    dialog.close();
    onAcknowledge();
  };
  const contactUs = () => {
    dialog.close();
    onContactUs();
  };

  return (
    <IgDialog
      title="Onsite editor is changing on August 18"
      showDialog={dialog.isOpen}
      handleClose={() => dialog.close()}
      handleYesClick={acknowledge}
      yesButtonText="Got it"
      handleNoClick={contactUs}
      showCloseIcon={true}
      noButtonText="Contact us"
      dontUseDialogContent={true}
      dialogHeight={null}
      rawContent={
        <Stack spacing={3}>
          <IgTypography>
            Starting August 18, content is created in the Visual Builder instead
            of the onsite editor. The onsite editor still works for price
            testing and previewing experiences. Can't use the Visual Builder?
            Contact us and we'll unblock you before the switch.
          </IgTypography>
        </Stack>
      }
    />
  );
};
